/* La Pièce Auto 42 — comportements de la refonte (barre catégories + chargement différé) */
(function () {
  'use strict';

  /* ---------- Barre catégories : ouverture au survol (desktop) et au clic/clavier ---------- */
  function initNav(nav) {
    if (nav.dataset.lpaReady) return;
    nav.dataset.lpaReady = '1';
    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-lpa-nav-item]'));
    var closeTimer = null;

    /* Si les liens ne tiennent pas sur une ligne, on masque le texte de droite plutôt que de le chevaucher */
    var list = nav.querySelector('.lpa-nav__list');
    var aside = nav.querySelector('.lpa-nav__aside');
    if (list && aside) {
      var fit = function () {
        nav.classList.remove('is-tight');
        if (list.scrollWidth > list.clientWidth + 1) nav.classList.add('is-tight');
      };
      fit();
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(nav);
      else window.addEventListener('resize', fit);
    }

    function close(item) {
      item.classList.remove('is-open');
      var btn = item.querySelector('.lpa-nav__trigger');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    function open(item) {
      items.forEach(function (other) { if (other !== item) close(other); });
      item.classList.add('is-open');
      var btn = item.querySelector('.lpa-nav__trigger');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.lpa-nav__trigger');
      if (!btn) return;

      btn.addEventListener('click', function () {
        if (item.classList.contains('is-open')) close(item); else open(item);
      });

      item.addEventListener('mouseenter', function () {
        if (!window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(closeTimer);
        open(item);
      });

      item.addEventListener('mouseleave', function () {
        if (!window.matchMedia('(hover: hover)').matches) return;
        closeTimer = setTimeout(function () { close(item); }, 160);
      });

      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      items.forEach(function (item) {
        if (item.classList.contains('is-open')) {
          close(item);
          var btn = item.querySelector('.lpa-nav__trigger');
          if (btn) btn.focus();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) items.forEach(close);
    });

    /* Onglets du panneau « Toutes les catégories » */
    nav.querySelectorAll('[data-lpa-tabs]').forEach(function (wrap) {
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('button[role="tab"]'));
      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('mouseenter', function () { select(tab); });
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (next) { e.preventDefault(); next.focus(); select(next); }
        });
      });
    });
  }

  /* ---------- Sections chargées à la demande via la Section Rendering API ---------- */
  function initDeferred(el) {
    var url = el.getAttribute('data-lpa-deferred');
    if (!url || el.dataset.lpaReady) return;
    el.dataset.lpaReady = '1';
    var load = function () {
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-lpa-deferred-content]');
          if (fresh && fresh.children.length) {
            el.innerHTML = fresh.innerHTML;
          } else {
            var section = el.closest('[data-lpa-hide-empty]');
            if (section) section.hidden = true;
          }
        })
        .catch(function () {
          var section = el.closest('[data-lpa-hide-empty]');
          if (section) section.hidden = true;
        });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else {
      load();
    }
  }

  /* ---------- Panier : code de réduction (tiroir + page panier), quantités et note sur la page panier ---------- */
  var cartBusy = false;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function cartPage() { return document.querySelector('[data-lpa-cart-page]'); }

  function sectionIds() {
    var page = cartPage();
    return page ? [page.getAttribute('data-section-id'), 'cart-icon-bubble'] : ['cart-drawer', 'cart-icon-bubble'];
  }

  function postCart(endpoint, payload) {
    payload.sections = sectionIds();
    payload.sections_url = window.location.pathname;
    return fetch(root + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var err = new Error(data.description || data.message || r.status); err.data = data; throw err; }
        return data;
      });
    });
  }

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* Re-rend le panier (page ou tiroir) à partir de la réponse de l'API, puis affiche un éventuel message */
  function refreshCart(state, message) {
    var page = cartPage();
    if (state && state.sections) {
      if (page) {
        var fresh = parse(state.sections[page.getAttribute('data-section-id')]).querySelector('[data-lpa-cart-page]');
        if (fresh) page.innerHTML = fresh.innerHTML;
      } else {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
      }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && state.sections['cart-icon-bubble']) {
        var b = parse(state.sections['cart-icon-bubble']).querySelector('.shopify-section');
        if (b) bubble.innerHTML = b.innerHTML;
      }
    }
    var msg = document.querySelector('[data-lpa-discount-error]');
    if (msg) { msg.textContent = message || ''; msg.hidden = !message; }
  }

  function currentCodes(scope) {
    return Array.prototype.map.call(scope.querySelectorAll('[data-lpa-discount-code]'), function (el) {
      return el.getAttribute('data-lpa-discount-code');
    });
  }

  function withLock(scope, task) {
    if (cartBusy) return;
    cartBusy = true;
    if (scope) scope.classList.add('is-loading');
    task().then(function () {}, function () {}).then(function () {
      cartBusy = false;
      if (scope) scope.classList.remove('is-loading');
    });
  }

  function applyDiscount(scope) {
    var input = scope.querySelector('input');
    var wanted = (input.value || '').trim();
    if (!wanted) { input.focus(); return; }
    var codes = currentCodes(scope);
    if (codes.some(function (c) { return c.toLowerCase() === wanted.toLowerCase(); })) {
      refreshCart(null, 'Ce code est déjà appliqué.');
      return;
    }
    withLock(scope, function () {
      return postCart('cart/update.js', { discount: codes.concat(wanted).join(',') })
        .then(function (state) {
          var found = (state.discount_codes || []).find(function (d) { return d.code.toLowerCase() === wanted.toLowerCase(); });
          if (found && found.applicable) return refreshCart(state);
          /* Code inconnu ou non applicable : on le retire pour ne pas le garder dans le panier */
          return postCart('cart/update.js', { discount: codes.join(',') }).then(function (clean) {
            refreshCart(clean, 'Le code « ' + wanted + ' » n’est pas valide ou ne s’applique pas à votre panier.');
          });
        })
        .catch(function () { refreshCart(null, 'Impossible d’appliquer le code pour le moment. Réessayez.'); });
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-lpa-discount-form]');
    if (!form || form.tagName !== 'FORM') return;
    e.preventDefault();
    applyDiscount(form.closest('[data-lpa-discount]'));
  });

  document.addEventListener('keydown', function (e) {
    /* Sur la page panier, Entrée dans le champ code ne doit pas lancer le paiement */
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-lpa-discount-input]')) return;
    e.preventDefault();
    applyDiscount(e.target.closest('[data-lpa-discount]'));
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var apply = e.target.closest('[data-lpa-discount-apply]');
    if (apply) { applyDiscount(apply.closest('[data-lpa-discount]')); return; }

    var remove = e.target.closest('[data-lpa-discount-remove]');
    if (remove) {
      var scope = remove.closest('[data-lpa-discount]');
      var code = remove.closest('[data-lpa-discount-code]').getAttribute('data-lpa-discount-code');
      withLock(scope, function () {
        return postCart('cart/update.js', { discount: currentCodes(scope).filter(function (c) { return c !== code; }).join(',') })
          .then(function (state) { refreshCart(state); })
          .catch(function () { refreshCart(null, 'Impossible de retirer le code pour le moment.'); });
      });
      return;
    }

    var qty = e.target.closest('[data-lpa-cart-page] [data-lpa-qty]');
    if (qty) {
      var line = qty.closest('[data-line]');
      withLock(line, function () {
        return postCart('cart/change.js', { line: Number(line.getAttribute('data-line')), quantity: Number(qty.getAttribute('data-lpa-qty')) })
          .then(function (state) { refreshCart(state); })
          .catch(function (err) {
            var box = line.querySelector('.lpa-cart-line__error');
            if (box) { box.textContent = err.message || 'Mise à jour impossible.'; box.hidden = false; }
          });
      });
    }
  });

  var noteTimer = null;
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-lpa-cart-note]')) return;
    clearTimeout(noteTimer);
    var value = e.target.value;
    noteTimer = setTimeout(function () {
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: value }) });
    }, 500);
  });

  /* ---------- Date de livraison estimée (calculée côté navigateur pour rester juste malgré le cache) ---------- */
  function initEta(el) {
    var days = parseInt(el.getAttribute('data-days'), 10) || 0;
    var business = el.getAttribute('data-business') === 'true';
    var d = new Date();
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (!business || (wd !== 0 && wd !== 6)) added++;
    }
    var label = d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
    el.textContent = 'le ' + label;
  }

  /* ---------- Page contact : champs selon le motif, pré-remplissage par l'URL, validation ---------- */
  function initContact(form) {
    if (form.dataset.lpaReady) return;
    form.dataset.lpaReady = '1';
    var radios = Array.prototype.slice.call(form.querySelectorAll('input[name="contact[Motif]"]'));
    var groups = Array.prototype.slice.call(form.querySelectorAll('[data-show-for]'));
    var motifError = form.querySelector('[data-error-for="motif"]');
    if (!radios.length) return;

    function current() {
      var r = radios.find(function (x) { return x.checked; });
      return r ? r.getAttribute('data-motif') : '';
    }

    function sync() {
      var m = current();
      groups.forEach(function (g) {
        var show = !!m && g.getAttribute('data-show-for').split(' ').indexOf(m) > -1;
        g.hidden = !show;
        g.querySelectorAll('input, textarea, select').forEach(function (i) { i.disabled = !show; });
      });
      if (m && motifError) motifError.hidden = true;
    }

    var params = new URLSearchParams(window.location.search);
    var wanted = params.get('motif');
    if (wanted && !current()) {
      var r = radios.find(function (x) { return x.getAttribute('data-motif') === wanted; });
      if (r) r.checked = true;
    }
    var piece = params.get('piece');
    var pieceInput = form.querySelector('[data-lpa-contact-piece]');
    if (piece && pieceInput && !pieceInput.value) pieceInput.value = piece;

    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();

    form.addEventListener('submit', function (e) {
      if (!current()) {
        e.preventDefault();
        if (motifError) motifError.hidden = false;
        radios[0].focus();
        form.querySelector('.lpa-contact__motifs').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var invalid = Array.prototype.slice.call(form.querySelectorAll('input[required]:not([type="radio"]), textarea[required]'))
        .find(function (i) { return !i.disabled && !i.checkValidity(); });
      if (invalid) {
        e.preventDefault();
        invalid.setAttribute('aria-invalid', 'true');
        invalid.reportValidity();
      }
    });

    form.addEventListener('input', function (e) {
      if (e.target.getAttribute('aria-invalid') === 'true' && e.target.checkValidity()) e.target.removeAttribute('aria-invalid');
    });
  }

  function boot() {
    /* Footer mobile : colonnes de liens repliées par défaut */
    if (window.matchMedia('(max-width: 749px)').matches) {
      document.querySelectorAll('[data-lpa-footer-col]').forEach(function (d) { d.removeAttribute('open'); });
    }
    var contact = document.getElementById('LpaContactForm');
    if (contact) initContact(contact);
    document.querySelectorAll('[data-lpa-eta]').forEach(initEta);
    document.querySelectorAll('[data-lpa-nav]').forEach(initNav);
    document.querySelectorAll('[data-lpa-deferred]').forEach(initDeferred);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Copie du code promotionnel : délégation pour les sections rechargées par Shopify. */
(function () {
  'use strict';
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-lpa-copy-code]');
    if (!button || button.disabled) return;
    var offer = button.closest('.lpa-pca10');
    var label = button.querySelector('[data-lpa-copy-label]');
    var status = offer.querySelector('[data-lpa-copy-status]');
    var code = button.getAttribute('data-lpa-copy-code');
    button.disabled = true;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(code);
      } else {
        var field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;left:-9999px;top:0;';
        document.body.appendChild(field);
        var copied = false;
        try {
          field.select();
          copied = document.execCommand('copy');
        } finally {
          field.remove();
          button.focus({preventScroll: true});
        }
        if (!copied) throw new Error('Copy unavailable');
      }
      label.textContent = 'Code copié !';
      status.textContent = 'PCA10 copié ! Collez-le au moment du paiement.';
    } catch (error) {
      label.textContent = 'Copier le code';
      status.textContent = 'Copie indisponible : saisissez PCA10 au moment du paiement.';
    } finally {
      button.disabled = false;
    }
  });
})();
